import React from 'react'
const MobileContext = React.createContext()
export const { Provider, Consumer } = MobileContext
export const withContext = (Component) => (props) => (
  <Consumer>{(value) => <Component {...props} context={value} />}</Consumer>
)
export default MobileContext
